import React, { useState } from 'react';
import { ShowButton, EditButton, useRecordContext } from 'react-admin';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteButton from '../../Button/DeleteButton';
import { GridStyles } from '../../../../../theme/skin/poc/styles';

export default function Actions(props) {
  const {
    view,
    edit,
    delete: allowDelete,
    customOptionsBefore,
    customOptionsAfter,
    ...restProps
  } = props;

  const record = useRecordContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;
  const classes = GridStyles();

  if (!record) return null;

  const ITEM_HEIGHT = 48;

  let conditions = {
    view:   !!view ? view : false,
    edit:   !!edit ? edit : false,
    delete: !!allowDelete ? allowDelete : false,
  };

  Object.keys(conditions).forEach(k => {
    if (typeof conditions[k] === 'function') {
      conditions[k] = conditions[k](record);
    }
  });

  let options = [];
  if (customOptionsBefore && typeof customOptionsBefore === 'function') {
    const customOptionsBeforeResult = customOptionsBefore(record);
    if (!!customOptionsBeforeResult) {
      options.push(customOptionsBeforeResult);
    }
  }

  if (conditions.view) {
    options.push(<ShowButton {...restProps} className={classes.actionItem}/>);
  }
  if (conditions.edit) {
    options.push(<EditButton {...restProps} className={classes.actionItem}/>);
  }
  if (conditions.delete) {
    options.push(<DeleteButton {...restProps} record={record} className={classes.actionItem}/>);
  }

  if (customOptionsAfter && typeof customOptionsAfter === 'function') {
    const customOptionsAfterResult = customOptionsAfter(record);
    if (!!customOptionsAfterResult) {
      if (Array.isArray(customOptionsAfterResult)) {
        options.push(...customOptionsAfterResult);
      } else {
        options.push(customOptionsAfterResult);
      }
    }
  }

  if (!options.length) {
    return null;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem key={option.key || index} onClick={handleClose}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export function GridRowActionsRenderer(record, props) {
  return <Actions record={record} {...props} />;
}